import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { canAccess, firstAccessiblePath } from "@/components/AdminTabs";
import AdminConsentLog from "@/pages/AdminConsentLog";

export default function AdminHome() {
  const { user } = useAuth();
  if (canAccess(user, "consent-log")) return <AdminConsentLog />;
  const dest = firstAccessiblePath(user);
  if (dest && dest !== "/admin") return <Navigate to={dest} replace />;
  return <AdminConsentLog />;
}
